module.exports = __webpack_public_path__ + "static/media/flags_ECU.a4ffd89a.svg";